import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, SkipForwardIcon } from 'lucide-react';
interface QuestionSlideProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  options: {
    id: string;
    text: string;
  }[];
  onAnswer: (optionId: string) => void;
  onBack: () => void;
  onSkip: () => void;
  canGoBack: boolean;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 14
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut'
    }
  }
};
export function QuestionSlide({
  questionNumber,
  totalQuestions,
  question,
  options,
  onAnswer,
  onBack,
  onSkip,
  canGoBack
}: QuestionSlideProps) {
  return <div className="flex-1 flex items-center justify-center px-5 py-8" data-id="element-109">
      <motion.div className="w-full max-w-sm" variants={containerVariants} initial="hidden" animate="visible" key={question} data-id="element-110">
        <motion.div variants={itemVariants} className="mb-6" data-id="element-111">
          {/* Back / Skip row */}
          <div className="flex items-center justify-between mb-4" data-id="element-112">
            {canGoBack ? <button onClick={onBack} className="flex items-center gap-1 text-xs font-semibold text-clinical-muted active:text-clinical-text transition-colors" data-id="element-113">
                <ArrowLeftIcon className="w-3.5 h-3.5" data-id="element-114" />
                Back
              </button> : <div data-id="element-115" />}
            <button onClick={onSkip} className="flex items-center gap-1 text-xs font-semibold text-clinical-muted active:text-clinical-text transition-colors" data-id="element-116">
              Skip
              <SkipForwardIcon className="w-3.5 h-3.5" data-id="element-117" />
            </button>
          </div>

          {/* Progress */}
          <div className="flex items-center gap-3 mb-5" data-id="element-118">
            <span className="text-[11px] font-bold text-era-red uppercase tracking-wider whitespace-nowrap" data-id="element-119">
              {questionNumber} / {totalQuestions}
            </span>
            <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-120">
              <motion.div className="h-full bg-era-red rounded-full" initial={{
              width: 0
            }} animate={{
              width: `${questionNumber / totalQuestions * 100}%`
            }} transition={{
              duration: 0.5,
              ease: 'easeOut'
            }} data-id="element-121" />
            </div>
          </div>
          <h2 className="text-xl font-bold text-clinical-text leading-snug" data-id="element-122">
            {question}
          </h2>
        </motion.div>

        <div className="grid gap-2.5" data-id="element-123">
          {options.map(option => <motion.button key={option.id} variants={itemVariants} whileTap={{
          scale: 0.97
        }} onClick={() => onAnswer(option.id)} className="w-full bg-white border-2 border-gray-100 rounded-2xl px-4 py-3.5 text-left active:border-era-red active:bg-era-red-light transition-all duration-150" data-id="element-124">
              <span className="text-sm font-semibold text-clinical-text" data-id="element-125">
                {option.text}
              </span>
            </motion.button>)}
        </div>
      </motion.div>
    </div>;
}